class DiscountForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._discountField = this._elem.querySelector('[data-discount-field]')
    }

    onInit () {
        this._elem.addEventListener('submit', e => {
            e.preventDefault()
            let valid = this._elem.reportValidity()
            if (valid) {
                window.location = `/checkout?discount=${this._discountField.value.trim()}`
            }
        })
    }
}

export default DiscountForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/DiscountForm.js